import { FormContextValues } from '@dreryk/react-common';
import { FormController } from '@dreryk/react-components';

const PASSWORD_CHANGE_ENABLED_FIELD_NAME = 'passwordChangeEnabled';

export type PasswordChangeEnabledFormBeanPart<VALUE extends boolean = boolean> = {
   [PASSWORD_CHANGE_ENABLED_FIELD_NAME]: VALUE;
};

type PasswordChangeEnabledFieldProps = Pick<FormContextValues<PasswordChangeEnabledFormBeanPart>, 'register'>;

export const PasswordChangeEnabledField = (props: PasswordChangeEnabledFieldProps): JSX.Element => {
   const controller = props.register(PASSWORD_CHANGE_ENABLED_FIELD_NAME);

   return <FormController controller={controller} />;
};
